<i class="fas fa-bars icono-menu-web" (click)="mostrarOcultarMenuMovil()"></i>
<p-menubar id="menuBarWeb"class="menu-web" [model]="items"></p-menubar>
<p-megaMenu [hidden]="!showMenuMovil" id="menuBarMovil"class="menu-movil" [model]="items" orientation="vertical" (click)="mostrarOcultarMenuMovil()"></p-megaMenu>